// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:16:02

export default {
  "id": "obby-3d-sprunki-parkour",
  "slug": "obby-3d-sprunki-parkour",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7ed6f14336f94414a38f89da673bbfa7-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7ed6f14336f94414a38f89da673bbfa7/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Obby 3D Sprunki Parkour",
      "description": "Obby 3D Sprunki Parkour combines the best elements of obstacle challenges and parkour gameplay in an immersive 3D environment. The goal? Navigate through increasingly complex levels filled with moving platforms, tricky jumps, and narrow ledges while collecting coins and power-ups along the way. Each level offers unique challenges that test your timing, reflexes, and problem-solving skills.",
      "instructions": "How to Play\nStart Playing: Open your browser and visit your favorite gaming platform. Search for \"Obby 3D Sprunki Parkour\" to launch the game instantly.\nControls: Use the arrow keys or WASD to move, jump, and navigate. Precision and timing are key to mastering each level.\nCollect Coins: Grab coins scattered across the level for extra points and special rewards.\nAvoid Obstacles: Jump over gaps, dodge moving platforms, and stay on track to reach the finish line.",
      "genres": [
        "Agility",
        "Simulation"
      ],
      "tags": [
        "3d",
        "parkour",
        "roblox"
      ]
    },
    "zh-CN": {
      "title": "Obby 3D 空中公园跑酷",
      "description": "Obby 3D Sprunki 跑酷游戏将障碍挑战和跑酷游戏的最佳元素结合在一个沉浸式的3D环境中。目标？在移动平台、复杂跳跃和狭窄边缘的关卡中穿梭，沿途收集金币和增益道具。每个关卡都提供独特的挑战，考验你的时机、反应和解决问题的能力。",
      "instructions": "如何游玩\n开始游玩：打开您的浏览器并访问您喜欢的游戏平台。搜索“Obby 3D Sprunki 跑酷”即可立即启动游戏。\n控制方式：使用方向键或 WASD 移动、跳跃和导航。精准度和时机是掌握每个关卡的关键。\n收集金币：拾取关卡中散布的金币以获得额外分数和特殊奖励。\n避开障碍：跳过缝隙，躲避移动的平台，保持路线以到达终点线。",
      "genres": [
        "敏捷性",
        "模拟"
      ],
      "tags": [
        "三维",
        "跑酷",
        "Roblox"
      ]
    },
    "zh-TW": {
      "title": "Obby 3D 粒子跳躍樂園",
      "description": "Obby 3D Sprunki 運動挑戰遊戲結合了障礙挑戰和運動遊戲的最佳元素，在沉浸式的3D環境中進行。目標是通過越來越複雜的關卡，關卡中充滿移動平台、複雜跳躍和狹窄邊緣，沿途收集金幣和強化道具。每個關卡都提供獨特的挑戰，測試你的時間感、反應能力和問題解決技巧。",
      "instructions": "如何遊玩\n開始遊玩：打開您的瀏覽器並訪問您最喜歡的遊戲平台。搜索“Obby 3D Sprunki Parkour”即可立即啟動遊戲。\n控制方式：使用方向鍵或 WASD 鍵來移動、跳躍和導航。精準度和時間掌握是精通每個關卡關鍵。\n收集金幣：抓取關卡中分佈的金幣以獲得額外分數和特殊獎勵。\n避免障礙：跳過縫隙、躲避移動的平台，並保持在正確的路徑上以達到終點線。",
      "genres": [
        "敏捷性",
        "模擬"
      ],
      "tags": [
        "3D",
        "攀爬跳躍",
        "Roblox"
      ]
    },
    "zh-HK": {
      "title": "Obby 3D 粉碎跳躍樂園",
      "description": "Obby 3D Sprunki Parkour 結合了挑戰障礙和疾走遊戲的最佳元素，在一個沉浸式的3D環境中。目標？穿過越來越複雜的關卡，關卡內充滿移動平台、棘手的跳躍和狹窄的邊緣，沿途收集硬幣和加強道具。每個關卡都提供獨特的挑戰，測試你的時間感、反應能力和解題技巧。",
      "instructions": "如何遊玩\n開始遊玩：打開您的瀏覽器並造訪您最喜愛的遊戲平台。搜索「Obby 3D Sprunki Parkour」即可立即啟動遊戲。\n控制方式：使用方向鍵或 WASD 鍵來移動、跳躍和導航。精準度和時間感是掌握每個關卡關鍵。\n收集金幣：抓取關卡中散布的金幣，以獲得額外分數和特殊獎勵。\n避開障礙：跳過橫越的縫隙、躲避移動的平台，並保持在正確路徑上，以達到終點線。",
      "genres": [
        "靈巧度",
        "模擬"
      ],
      "tags": [
        "3D",
        "攀擔",
        "Roblox"
      ]
    },
    "ja": {
      "title": "オビー3D スプリンキーパークール",
      "description": "Obby 3D Sprunki Parkourは、障害物挑戦とパークアウトゲームの最も良い要素を immersive 3D環境で組み合わせています。目標は、動くプラットフォーム、難しいジャンプ、そして狭いレッジが満載の次第に複雑化するレベルを通過しながら、コインとパワーアップを収集することです。各レベルは、タイミング、反応、そして問題解決スキルを試すユニークな挑戦を提供します。",
      "instructions": "遊び方\nスタート：ブラウザを開き、お気に入りのゲームプラットフォームにアクセスしてください。 「Obby 3D Sprunki Parkour」を検索してゲームをすぐにスタートします。\nコントロール：矢印キーやWASDを使用して移動、ジャンプ、ナビゲートします。精度とタイミングが各レベルをマスターする鍵となります。\nコインを集める：レベル内に散らばっているコインを拾ってボーナスポイントと特別な報酬を手に入れます。\n障害物を避ける：ギャップを飛び越え、動くプラットフォームを避け、フィニッシュラインにたどり着くために道を守ります。",
      "genres": [
        "敏捷度",
        "シミュレーション"
      ],
      "tags": [
        "3D",
        "パルコル",
        "ロブロックス"
      ]
    },
    "ko": {
      "title": "오비 3D 스프끄니 파크라우트",
      "description": "Obby 3D Sprunki 파크라는 게임은 장애물 과제와 파크라 게임의 최고 요소를 몰입감 있는 3D 환경에서 결합하여 제공합니다. 목표는 움직이는 플랫폼, 복잡한 점프, 좁은 돌보기 등으로 가득한 점점 더 복잡한 레벨을 돌아다니면서 금화와 파워업을 모으는 것입니다. 각 레벨은 타이밍, 반사신경, 문제 해결 능력을 테스트하는 독특한 과제를 제공합니다.",
      "instructions": "게임玩法\n게임 시작하기: 브라우저를 엽니다. 최고의 게임 플랫폼에 접속하여 \"Obby 3D Sprunki Parkour\"을 검색하여 즉시 게임을 시작합니다.\n컨트롤: 화살표 키 또는 WASD 키를 사용하여 이동, 점프 및 탐색합니다. 정확성과 시간 조절은 각 레벨을 완성하는 데 중요합니다.\n코인 수집: 레벨 전체에 퍼져 있는 코인을 집어 들어 추가 점수와 특별 보상을 받습니다.\n장애물 회피: 구간을 뛰어넘치고 움직이는 플랫폼을 피하며 목적지에 도달하십시오.",
      "genres": [
        "민첩성",
        "시뮬레이션"
      ],
      "tags": [
        "3D",
        "파크라우르",
        "로빅스"
      ]
    },
    "fr": {
      "title": "Obby 3D Sprunki Parcours",
      "description": "Obby 3D Sprunki Parkour combine les meilleurs éléments des défis d'obstacles et du gameplay de parkour dans un environnement immersif en 3D. Le but ? Parcourir des niveaux de plus en plus complexes remplis de plateformes mobiles, de sauts délicats et de rebords étroits tout en collectant des pièces et des améliorations au fil du chemin. Chaque niveau propose des défis uniques qui testent votre timing, vos réflexes et vos compétences en résolution de problèmes.",
      "instructions": "Comment jouer\nCommencez à jouer : Ouvrez votre navigateur et rendez-vous sur votre plateforme de jeu préférée. Recherchez \"Obby 3D Sprunki Parkour\" pour lancer le jeu immédiatement.\nContrôles : Utilisez les flèches ou WASD pour vous déplacer, sauter et naviguer. Précision et timing sont essentiels pour maîtriser chaque niveau.\nCollectez des pièces : Ramassez les pièces réparties dans le niveau pour des points supplémentaires et des récompenses spéciales.\nÉvitez les obstacles : Sautez par-dessus les espaces, esquivez-vous aux plateformes mobiles et restez sur la piste pour atteindre la ligne d'arrivée.",
      "genres": [
        "Agilité",
        "Simulation"
      ],
      "tags": [
        "3D",
        "parkour",
        "Roblox"
      ]
    }
  }
};
